<template>
  <v-container fluid pa-0 p-t grid-list id="innerBanner">
    <v-layout>
      <v-flex>
        <client-only>
          <GptAd
            v-if="!isLoading"
            :ad-unit="dfpToShow.adunit"
            :is-responsive="true"
            :size="dfpToShow.dfpSize"
          />
        </client-only>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  components: {},
  props: {
    isHitech: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isMobile: null,
      generalDFP: {
        adunit: '3177829/search_results_desktop',
        dfpSize: [925, 100],
        id: '1585653598211-0',
      },
      generalMobileDFP: {
        adunit: '3177829/search_results_mob',
        dfpSize: [320, 50],
        id: '1585638687340-0',
      },
      hitechDFP: {
        adunit: '3177829/search_results_desktop_hitech',
        dfpSize: [925, 100],
        id: '1600849531015-0',
      },
      hightecMobileDFP: {
        adunit: '3177829/searchresults_mob_hitech',
        dfpSize: [320, 50],
        id: '1600850860042-0',
      },
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 600
  },
  computed: {
    dfpToShow() {
      if (this.isHitech) {
        return this.isMobile ? this.hightecMobileDFP : this.hitechDFP
      } else {
        return this.isMobile ? this.generalMobileDFP : this.generalDFP
      }
    },
  },
}
</script>
